import { render, staticRenderFns } from "./DoctorFilters.vue?vue&type=template&id=1653edfa&"
import script from "./DoctorFilters.vue?vue&type=script&lang=js&"
export * from "./DoctorFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports